<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
<!--    <TheAside/>-->
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main mt-1">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import {authLogout} from "@/security/index";
import {EXP_TOKEN} from '../constant'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },
  data() {
    return {
      intervalAutoLogout: null,
    }
  },
  mounted() {
    this.countAutoLogout();
  },
  methods: {
    countAutoLogout() {
      let exp_token = localStorage.getItem(EXP_TOKEN)
      if (exp_token) {
        let expiredTime = new Date(exp_token * 1)
        this.intervalAutoLogout = setInterval(() => {
          let time = new Date();
          if (time >= expiredTime) {
            authLogout()
          }
        }, 1000)
      }
    },
  },
  destroyed() {
  },
  computed: {},
}
</script>

<style scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
